const mainModule = {
  state: {
    lang: null,
    currency: null,
    token: null,
    email: null,
    userId: null,
    docType: null,
    app: null,
    referral_code: null,
    ipCountry: null,
    acceptedCookies: null,
    uuid: null,
  },

  mutations: {
    SET_LANGUAGE(state, language) {
      state.lang = language;
    },
    SET_CURRENCY(state, currency) {
      state.currency = currency;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_EMAIL(state, email) {
      state.email = email;
    },
    SET_USER_ID(state, userId) {
      state.userId = userId;
    },
    SET_DOC_TYPE(state, docType) {
      state.docType = docType;
    },
    REMOVE_USER_DATA(state) {
      state.token = null;
      state.email = null;
      state.userId = null;
    },
    SET_APP(state, value) {
      state.app = value;
    },
    SET_REFERRAL(state, value) {
      state.referral_code = value;
    },
    SET_IP_COUNTRY(state, value) {
      state.ipCountry = value;
    },
    SET_COOKIES_CONFIG(state, value) {
      state.acceptedCookies = value;
    },
    SET_UUID(state, value) {
      state.uuid = value;
    },
  },

  actions: {
    setLanguage(context, language) {
      context.commit('SET_LANGUAGE', language);
    },
    setCurrency(context, currency) {
      context.commit('SET_CURRENCY', currency);
    },
    setToken(context, token) {
      context.commit('SET_TOKEN', token);
    },
    setEmail(context, email) {
      context.commit('SET_EMAIL', email);
    },
    setUserId(context, userId) {
      context.commit('SET_USER_ID', userId);
    },
    setDocType(context, docType) {
      context.commit('SET_DOC_TYPE', docType);
    },
    removeUserData(context) {
      context.commit('REMOVE_USER_DATA');
    },
    setApp(context, value) {
      context.commit('SET_APP', value);
    },
    setReferral(context, value) {
      context.commit('SET_REFERRAL', value);
    },
    setIpCountry(context, value) {
      context.commit('SET_IP_COUNTRY', value);
    },
    setCookiesConfig(context, value) {
      context.commit('SET_COOKIES_CONFIG', value);
    },
    setUUID(context, value) {
      context.commit('SET_UUID', value);
    },
  },
};

export default mainModule;
